'use strict';

require('./autorisations-minieres.css');
require('./autorisations-minieres.routes');
require('./autorisations-minieres.controller');
require('./autorisations-minieres-details.controller');
require('./autorisations-minieres.service');
